import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/Common/ErrorBoundary';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Common/Footer';
import Home from './components/Home/Home';
import Login from './components/Auth/Login';
import OTPVerify from './components/Auth/OTPVerify';
import CategoryList from './components/Categories/CategoryList';
import SubCategoryList from './components/Categories/SubCategoryList';
import BusinessListingPage from './components/Categories/BusinessListingPage';
import BusinessDetail from './components/Categories/BusinessDetail';
import AddBusiness from './components/Business/AddBusiness';
import MyBusiness from './components/Business/MyBusiness';
import BusinessLanding from './components/Business/BusinessLanding';
import Account from './components/Account/Account';
import CreateProfile from './components/Account/CreateProfile';
import DailyNeeds from './components/Common/DailyNeeds';
import AdSet from './components/AdSet/AdSet';
import DigitalPoster from './components/DigitalPoster/DigitalPoster';
import VisitingCard from './components/VisitingCard/VisitingCard';
import SupportCenter from './components/Common/SupportCenter';
import ReportProblem from './components/Common/ReportProblem';
import Offers from './components/Common/Offers';
import ReferEarn from './components/Common/ReferEarn';
import Messages from './components/Common/Messages';
import AdSetNotification from './components/AdSet/AdSetNotification';
import AppSettings from './components/Common/AppSettings';
import SearchResults from './components/Categories/SearchResults';
import Blog from './components/Blog/Blog';
import BlogDetail from './components/Blog/BlogDetail';
import PrivacyPolicy from './components/Policies/PrivacyPolicy';
import TermsConditions from './components/Policies/TermsConditions';
import CancellationRefund from './components/Policies/CancellationRefund';
import FloatSupport from './components/Common/FloatSupport';

function Layout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <FloatSupport />
    </>
  );
}

function AuthLayout({ children }) {
  return <main>{children}</main>;
}

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" />
          <Routes>
          {/* Auth - no navbar/footer */}
          <Route path="/login" element={<AuthLayout><Login /></AuthLayout>} />
          <Route path="/otp-verify" element={<AuthLayout><OTPVerify /></AuthLayout>} />
          {/* Main pages */}
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/categories/:type" element={<Layout><CategoryList /></Layout>} />
          <Route path="/category/:categoryName" element={<Layout><SubCategoryList /></Layout>} />
          <Route path="/subcategory/:categoryName/:subCategoryName" element={<Layout><BusinessListingPage /></Layout>} />
          <Route path="/business/:id" element={<Layout><BusinessDetail /></Layout>} />
          <Route path="/daily-needs" element={<Layout><DailyNeeds /></Layout>} />
          <Route path="/add-business" element={<Layout><AddBusiness /></Layout>} />
          <Route path="/business-listing" element={<Layout><BusinessLanding /></Layout>} />
          <Route path="/my-business" element={<Layout><MyBusiness /></Layout>} />
          <Route path="/account" element={<Layout><Account /></Layout>} />
          <Route path="/create-profile" element={<Layout><CreateProfile /></Layout>} />
          <Route path="/adset" element={<Layout><AdSet /></Layout>} />
          <Route path="/digital-poster" element={<Layout><DigitalPoster /></Layout>} />
          <Route path="/visiting-card" element={<Layout><VisitingCard /></Layout>} />
          <Route path="/support" element={<Layout><SupportCenter /></Layout>} />
          <Route path="/report" element={<Layout><ReportProblem /></Layout>} />
          <Route path="/offers" element={<Layout><Offers /></Layout>} />
          <Route path="/refer" element={<Layout><ReferEarn /></Layout>} />
          <Route path="/messages" element={<Layout><Messages /></Layout>} />
          <Route path="/adset-notifications" element={<Layout><AdSetNotification /></Layout>} />
          <Route path="/settings" element={<Layout><AppSettings /></Layout>} />
          <Route path="/search" element={<Layout><SearchResults /></Layout>} />
          <Route path="/blog" element={<Layout><Blog /></Layout>} />
          <Route path="/blog/:slug" element={<Layout><BlogDetail /></Layout>} />
          <Route path="/privacy-policy" element={<Layout><PrivacyPolicy /></Layout>} />
          <Route path="/terms-conditions" element={<Layout><TermsConditions /></Layout>} />
          <Route path="/cancellation-refund" element={<Layout><CancellationRefund /></Layout>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}
